import { loading } from '@/shared/utils/UIHelper'
import CountryRepository from '@/shared/http/repositories/geo/country.js'
import StateRepository from '@/shared/http/repositories/geo/state.js'
import CityRepository from '@/shared/http/repositories/geo/city.js'

const GeoMixin = {
  watch: {
    'form.paisOrigemID.value': function (value) {
      if (value) {
        // this.form.estadoOrigemID.value = null
        this.onChangeCountryStart(value)
      } else {
        this.form.estadoOrigemID.options = []
        this.form.estadoOrigemID.value = null
      }
    },
    'form.paisDestinoID.value': function (value) {
      if (value) {
        // this.form.estadoDestinoID.value = null
        this.onChangeCountryEnd(value)
      } else {
        this.form.estadoDestinoID.options = []
        this.form.estadoDestinoID.value = null
      }
    },
    'form.estadoOrigemID.value': function (value) {
      if (value) {
        // this.form.cidadeOrigemID.value = null
        this.onChangeStateStart(value)
      } else {
        this.form.cidadeOrigemID.options = []
        this.form.cidadeOrigemID.value = null
      }
    },
    'form.estadoDestinoID.value': function (value) {
      if (value) {
        // this.form.cidadeDestinoID.value = null
        this.onChangeStateEnd(value)
      } else {
        this.form.cidadeDestinoID.options = []
        this.form.cidadeDestinoID.value = null
      }
    }
  },
  methods: {
    onLoadAllCountry () {
      CountryRepository.GetAll()
        .then((response) => {
          if (response.data.code > 0) {
            this.form.paisOrigemID.options = this.onResultDropdown(response)
            this.form.paisDestinoID.options = this.onResultDropdown(response)
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onChangeCountryStart (id) {
      StateRepository.GetAllByCountryID(id)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.estadoOrigemID.options = this.onResultDropdown(response, null, f => f.sigla)
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onChangeCountryEnd (id) {
      StateRepository.GetAllByCountryID(id)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.estadoDestinoID.options = this.onResultDropdown(response, null, f => f.sigla)
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onChangeStateStart (id) {
      CityRepository.GetAllByStateID(id)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.cidadeOrigemID.options = this.onResultDropdown(response)
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onChangeStateEnd (id) {
      CityRepository.GetAllByStateID(id)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.cidadeDestinoID.options = this.onResultDropdown(response)
          }
          loading.close()
        })
        .catch(this.onException)
    }
  }
}

export default GeoMixin



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelrefund/mixins/GeoMixin.js